const colors = {
  button: 'darkgreen',
  notice: 'orange',
  header: 'darkgreen',
};

export default colors;
